<ng-container *ngIf="!item.hidden">
  <li class="nav-item coded-menu-caption">
    <label>{{ item.title }}</label>
  </li>
  <ng-container *ngFor="let item of item.children">
    <app-menu-group-horizontal *ngIf="item.type === 'group'" [item]="item"></app-menu-group-horizontal>
    <app-menu-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-menu-collapse>
    <app-menu-item *ngIf="item.type === 'item'" [item]="item"></app-menu-item>
  </ng-container>
</ng-container>
